"use strict";

exports.__esModule = true;
exports.wrap = wrap;
/* eslint-disable import/prefer-default-export */

function wrap(n, min, max) {
  var d = max - min;
  return n === max ? n : ((n - min) % d + d) % d + min;
}


//////////////////
// WEBPACK FOOTER
// ./~/google-map-react/lib/utils/lib_geo/wrap.js
// module id = 535
// module chunks = 0